import lucum1 from '../assets/lucum1.png'; // или .webp / .png – укажи актуальное расширение
import lucum2 from '../assets/lucum2.png';
import lucum3 from '../assets/lucum3.png';
import lucum4 from '../assets/lucum4.png';
import lucum5 from '../assets/lucum5.png';
import lucum6 from '../assets/lucum6.png';
import ardyunaberakan from '../assets/ardyunaberakan.png';
import service1 from '../assets/service1.png';
import service2 from '../assets/service2.png';
import service3 from '../assets/service3.png';
import service4 from '../assets/service4.png';
import service5 from '../assets/service5.png';
import service6 from '../assets/service6.png';
import service7 from '../assets/service7.png';
import news1 from '../assets/news1.png';
import news2 from '../assets/news2.png';
import news3 from '../assets/news3.png';

export const translations = {
    ARM: {
        // --- НАВИГАЦИЯ (ОБНОВЛЕНО) ---
        homeLink: 'Գլխավոր',
        aboutTitle: 'Մեր մասին',
        challengesTitle: 'Խնդիրներ',
        problemsTitle: 'Խնդիրներ', // Было timelineTitle
        solutionsTitle: 'Լուծումներ',
        industriesTitle: 'Ոլորտներ', // Было blogTitle
        technologiesTitle: 'Տեխնոլոգիաներ', // Новое
        partnersTitle: 'Գործընկերներ',
        projectsTitle: 'Նախագծեր', // Новое
        newsTitle: 'Նորություններ և վերլուծություն', // Новое
        contactTitle: 'Կապ',
        quickMenu: 'Արագ մենյու',
        socialTitle: 'Սոցիալական կապեր',

        // --- ПОДВАЛ (FOOTER) ---
        footerCompanyName: 'National Water Technologies Armenia LLC',
        footerAddress: 'Երևան, Հայաստան',
        footerPhone: '+37495040655',
        footerEmail: 'nwt.arm@gmail.com',
        footerRights: '© 2026 NWTA. Բոլոր իրավունքները պաշտպանված են։',
        footerTagline: 'Միջազգային ինժեներական ստանդարտ',
        footerRights: '© 2026 NWTA. Բոլոր իրավունքները պաշտպանված են։',
        websitetext1: " Կայքը պատրաստված է",
        websitetext2: "ծրագրավորման կենտրոնի կողմից։",

        // --- ГЛАВНАЯ (HERO) ---
        heroBadge: 'ՋՐԱՅԻՆ ՏԵԽՆՈԼՈԳԻԱՆԵՐ ԵՎ ԺԱՄԱՆԱԿԱԿԻՑ ԵՆԹԱԿԱՌՈՒՑՎԱԾՔՆԵՐ',
        heroTitle: 'ՀԱՅԱՍՏԱՆԻ ԱԶԳԱՅԻՆ',
        heroTitle2: 'ՋՐԱՅԻՆ ՏԵԽՆՈԼՈԳԻԱՆԵՐԻ ԻՆՏԵԳՐԱՏՈՐ',
        heroText: 'Ժամանակակից լուծումներ ջրի մաքրման, կեղտաջրերի մաքրման և վերաօգտագործման համար',
        btnSolutions: 'Կապվել մասնագետի հետ',
        btnContact: 'Ընտրել լուծում',
        directionsTitle: "Մեր հիմնական ուղղությունները",
        directions: [
            " Ջրի մաքրում և ջրապատրաստում",
            "Կեղտաջրերի մաքրում և վերաօգտագործում",
            "Արդյունաբերական ջրային լուծումներ",
            "Համայնքային և քաղաքային ենթակառուցվածքներ"
        ],

        // --- О НАС (ОБНОВЛЕННЫЙ ТЕКСТ) ---
        aboutFocusTitle: 'Մենք կառուցում ենք Հայաստանի ջրային ապագան',
        aboutFocusText: 'National Water Technologies Armenia (NWTA)-ն ազգային ինժեներական ընկերություն է, որը միավորում է առաջատար միջազգային տեխնոլոգիաները և մասնագիտական փորձը՝ Հայաստանի ջրային ենթակառուցվածքների զարգացման համար։ Մենք հավատում ենք, որ մաքուր ջուրը, անվտանգ շրջակա միջավայրը և ժամանակակից ինժեներական լուծումները երկրի կայուն զարգացման հիմքն են։',
        aboutWhatSetsUsApart: 'Ինչն է մեզ առանձնացնում',
        aboutHighlights: [
            'Անհատական մոտեցում յուրաքանչյուր նախագծին',
            'Տեխնիկական և բնապահպանական գնահատում',
            'Միջազգային փորձի միավորում տեղական պահանջների հետ',
            'Ավարտված նախագծերի հուսալի փորձ',
            'Արտադրանքի և սպասարկման ամբողջական շղթա'
        ],
        aboutIcons: ['Նախագծում', 'Իրականացում', 'Սպասարկում'],
        approachTitle: 'Մեր մոտեցումը',
        approachSubtitle: 'Մենք չենք վաճառում պարզապես սարքավորումներ',
        approachDesc: 'Մենք ուսումնասիրում ենք յուրաքանչյուր նախագծի առանձնահատկությունները, գնահատում ենք տեխնիկական և բնապահպանական պահանջները և առաջարկում ենք այնպիսի լուծումներ, որոնք ապահովում են արդյունավետություն, հուսալիություն և երկարաժամկետ արդյունք։',

        whatWeDoTitle: 'Ինչով ենք զբաղվում',
        whatWeDoIntro: 'NWTA-ն իրականացնում է ամբողջական ինժեներական նախագծեր՝',
        whatWeDoServices: [
            'Համայնքային կեղտաջրերի մաքրման համակարգեր',
            'Արդյունաբերական կեղտաջրերի մաքրում',
            'Խմելու ջրի մաքրման համակարգեր',
            'Տեղային կենսաբանական մաքրման կայաններ',
            'Ջրի վերաօգտագործման լուծումներ',
            'Ժամանակակից հանրային սանիտարական համակարգեր',
            'Ինժեներական նախագծում և տեխնիկական խորհրդատվություն',
            'Սարքավորումների մատակարարում, տեղադրում և սպասարկում'
        ],
        whatWeDoGoalTitle: 'Մեր նպատակը պարզ է',
        whatWeDoGoalText: 'Ստեղծել ավելի մաքուր, անվտանգ և տեխնոլոգիապես զարգացած Հայաստան՝ ժամանակակից ջրային լուծումների միջոցով։',
        whatWeDoMissionTitle: 'Մեր առաքելությունը',
        whatWeDoMissionText: 'Ստեղծել ժամանակակից, հուսալի և կայուն ջրային լուծումներ, որոնք կբարելավեն մարդկանց կյանքի որակը, կպաշտպանեն բնական ռեսուրսները և կնպաստեն Հայաստանի տնտեսական ու բնապահպանական զարգացմանը։',

        // --- ПРОБЛЕМЫ (НОВАЯ СТРАНИЦА) ---
        problemsMainTitle: 'Հայաստանի ջրային մարտահրավերները',
        problemsMainDesc: 'Ջուրը մեր ամենաթանկ բնական ռեսուրսներից է։ Սակայն ջրային ենթակառուցվածքների զարգացումը պահանջում է ժամանակակից և արդյունավետ լուծումներ։',
        problemsList: [
            {

                title: 'Կեղտաջրերի անբավարար մաքրում',
                desc: 'Չմաքրված կամ ոչ բավարար մաքրված կեղտաջրերը կարող են աղտոտել գետերը, լճերը և ստորերկրյա ջրերը։'
            },
            {

                title: 'Արդյունաբերական աղտոտում',
                desc: 'Արտադրական ձեռնարկությունների կեղտաջրերը հաճախ պահանջում են հատուկ մաքրման տեխնոլոգիաներ՝ բնապահպանական նորմերին համապատասխանելու համար։'
            },
            {

                title: 'Խմելու ջրի որակ',
                desc: 'Ջրի որակի պահպանումը կարևոր է բնակչության առողջության և անվտանգ ջրամատակարարման համար։'
            },
            {

                title: 'Նոր բնակելի թաղամասեր',
                desc: 'Բազմաթիվ նոր կառուցապատվող տարածքներ չունեն համապատասխան ջրային ենթակառուցվածքներ։'
            }
        ],
        problemsVisionLabel: "Մեր տեսլականը",
        problemsVisionHeading: "Յուրաքանչյուր խնդիր ունի իր լուծումը։",
        problemsVisionText: "NWTA-ն առաջարկում է ժամանակակից, արդյունավետ և երկարաժամկետ ինժեներական լուծումներ՝ համապատասխանեցված յուրաքանչյուր նախագծի պահանջներին։",
        problemsVisionFooter: "Մաքուր ջուր։ Ժամանակակից տեխնոլոգիաներ։ Կայուն ապագա։",
        // --- РЕШЕНИЯ ---
        solutionsPageTitle: 'Լուծումներ',
        solutionsSubtitle: 'Ժամանակակից ջրային լուծումներ Հայաստանի համար',
        solutionsDesc: 'NWTA-ն առաջարկում է ամբողջական ինժեներական լուծումներ ջրամատակարարման, կեղտաջրերի մաքրման և ջրային ենթակառուցվածքների զարգացման ոլորտում։',
        solutionsTabs: [
            {
                id: 'municipal',
                title: 'Համայնքային կեղտաջրերի մաքրում',
                desc: 'Ժամանակակից մաքրման կայաններ քաղաքների, համայնքների և բնակավայրերի համար։',
                image: lucum1,
                items: ['Կենսաբանական մաքրում', 'Մեխանիկական մաքրում', 'Տիղմի մշակում', 'Հոտերի վերահսկում', 'Ավտոմատ կառավարման համակարգեր']
            },
            {
                id: 'industrial',
                title: 'Արդյունաբերական կեղտաջրերի մաքրում',
                desc: 'Լուծումներ տարբեր արտադրական ճյուղերի համար։',
                image: lucum2,
                items: ['Սննդի արդյունաբերություն', 'Գինեգործություն', 'Կաթնամթերքի արտադրություն', 'Մետաղամշակում', 'Ավտոլվացման կետեր', 'Հանքարդյունաբերություն', 'Քիմիական արտադրություն']
            },
            {
                id: 'drinking',
                title: 'Ջրապատրաստում և ջրի մաքրում',
                desc: 'Մենք առաջարկում ենք ժամանակակից տեխնոլոգիաներ։',
                image: lucum3,
                items: ['Ֆիլտրացիա', 'Ուլտրամանուշակագույն ախտահանում (UV)', 'Մեմբրանային համակարգեր', 'Ածխային ֆիլտրեր', 'Ջրի որակի մշտադիտարկում']
            },
            {
                id: 'local',
                title: 'Տեղային մաքրման կայաններ',
                desc: 'Լուծումներ տարբեր օբյեկտների համար։',
                image: lucum4,
                items: ['Առանձնատներ', 'Բնակելի համալիրներ', 'Հյուրանոցներ', 'Դպրոցներ', 'Մանկապարտեզներ', 'Առողջարաններ', 'Հանգստյան գոտիներ']
            },
            {
                id: 'sanitary',
                title: 'Ժամանակակից հանրային սանիտարական համակարգեր',
                desc: 'Ինքնամաքրվող հանրային զուգարաններ և խելացի համակարգեր։',
                image: lucum5,
                items: ['Մոդուլային լուծումներ', 'Խելացի կառավարման համակարգեր', 'Հասանելիություն սահմանափակ շարժունակություն ունեցող անձանց համար', 'Էներգաարդյունավետ շահագործում']
            },
            {
                id: 'reuse',
                title: 'Ջրի վերաօգտագործում',
                desc: 'Մաքրված ջրի օգտագործում տարբեր նպատակներով։',
                image: lucum6,
                items: ['Ոռոգման համար', 'Կանաչ տարածքների սպասարկում', 'Տեխնիկական գործընթացներ', 'Արդյունաբերական նպատակներ']
            }
        ],
        principleTitle: 'Մեր սկզբունքը',
        principleText: 'Մենք առաջարկում ենք ոչ թե առանձին սարքավորումներ, այլ ամբողջական, արդյունավետ և երկարաժամկետ լուծումներ՝ հարմարեցված յուրաքանչյուր նախագծի պահանջներին։',
        principleHeading: '«Մեկ գործընկեր՝ ամբողջական լուծում»',
        principleStep1: 'Վերլուծություն ',
        principleStep2: 'Նախագծում',
        principleStep3: 'Տեխնոլոգիա',
        principleStep4: 'Իրականացում',
        principleStep5: 'Սպասարկում',

        // --- ОТРАСЛИ ---
        industriesPageTitle: 'Արդյունաբերություններ',
        industriesSubtitle: 'Լուծումներ յուրաքանչյուր ոլորտի համար',
        industriesDesc: 'Յուրաքանչյուր ոլորտ ունի իր առանձնահատկությունները, պահանջները և բնապահպանական մարտահրավերները։ NWTA-ն նախագծում և իրականացնում է լուծումներ՝ հաշվի առնելով յուրաքանչյուր օբյեկտի տեխնիկական և գործառնական պահանջները։',
        industries: [
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M7 17V9"/><path d="M12 17V5"/><path d="M17 17v-7"/></svg>',
                title: 'Համայնքներ և քաղաքներ',
                desc: 'Ջրամատակարարման, կեղտաջրերի հավաքման և մաքրման համակարգեր բնակավայրերի համար։',
                items: ['Քաղաքային ենթակառուցվածքներ', 'Համայնքային կայաններ', 'Մաքրման կայաններ', 'Ավտոմատ կառավարման'],
                image: 'https://mywikis-wiki-media.s3.us-central-1.wasabisys.com/armeniapedia/Square_From_Above.jpg'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18"/><path d="M8 4v16"/></svg>',
                title: 'Արդյունաբերություն',
                desc: 'Բարձր արդյունավետ, տեխնոլոգիապես զարգացած լուծումներ արտադրական օբյեկտների համար։',
                items: ['Սննդի արդյունաբերություն', 'Գինեգործություն', 'Կաթնամթերքի արտադրություն', 'Քիմիական արտադրություն'],
                image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnZI9LFArzKkditu531-EERiRrq1fQd9xqEdVTPMzuMNcfV6vNW0ZlS4hS&s=10'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Հյուրանոցներ և զբոսաշրջություն',
                desc: 'Հարմարավետ, անվտանգ և կայուն ջրային լուծումներ բնակարանային և հանրային օբյեկտների համար։',
                items: ['Հյուրանոցներ', 'Դպրոցներ', 'Առողջարաններ', 'Բնակելի համալիրներ'],
                image: 'https://greenrock.am/wp-content/uploads/2025/08/04-1-1-768x618.jpg'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Բնակելի համալիրներ',
                desc: 'Հարմարավետ, անվտանգ և կայուն ջրային լուծումներ բնակարանային և հանրային օբյեկտների համար։',
                items: ['Հյուրանոցներ', 'Դպրոցներ', 'Առողջարաններ', 'Բնակելի համալիրներ'],
                image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqbdLJvPXMqaZgkTuI2hL61ZORowlzGZU1zlkmBVHxiphnm0sDGmUW604&s=10'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Գյուղատնտեսություն',
                desc: 'Հարմարավետ, անվտանգ և կայուն ջրային լուծումներ բնակարանային և հանրային օբյեկտների համար։',
                items: ['Հյուրանոցներ', 'Դպրոցներ', 'Առողջարաններ', 'Բնակելի համալիրներ'],
                image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReZu8Lousi9d6e-JKUws1I8wePKtTWAeIOrNvohIctZBw_mj2P7P-F-fET&s=10'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Սննդի արդյունաբերություն և խմիչքների արտադրություն',
                desc: 'Հարմարավետ, անվտանգ և կայուն ջրային լուծումներ բնակարանային և հանրային օբյեկտների համար։',
                items: ['Հյուրանոցներ', 'Դպրոցներ', 'Առողջարաններ', 'Բնակելի համալիրներ'],
                image: 'https://loyalmachines.com/wp-content/uploads/2024/10/a-2-2.png'
            }
        ],

        whyTitle: "ԻՆՉՈՒ ԸՆՏՐԵԼ NWTA-Ն",
        whyItems: [
            "Համաշխարհային տեխնոլոգիաների ինտեգրում",
            "Անհատական ինժեներական լուծումներ",
            "Մեկ գործընկեր՝ նախագծից մինչև սպասարկում",
            "Տեղական պայմաններին հարմարեցված լուծումներ",
            "Ժամանակակից և էներգաարդյունավետ տեխնոլոգիաներ",
            "Երկարաժամկետ տեխնիկական աջակցություն"
        ],
        whyMissionTitle: "Մեր առաքելությունը",
        whyMissionText: "Ապահովել Հայաստանը ժամանակակից ջրային տեխնոլոգիաներով՝ ստեղծելով մաքուր, անվտանգ և կայուն միջավայր ապագա սերունդների համար։",

        // --- ПАРТНЕРЫ ---
        partnersPageTitle: 'Գործընկերներ',
        partnersTitle: 'Միջազգային տեխնոլոգիաներ։ Տեղական փորձ։ Մեկ ընդհանուր նպատակ։',
        partnersDesc: 'National Water Technologies Armenia (NWTA)-ն զարգացնում է միջազգային համագործակցության ցանց՝ միավորելով ջրային ոլորտի առաջատար արտադրողներին, ինժեներական ընկերություններին և տեխնոլոգիական գործընկերներին։ Մեր նպատակն է Հայաստանի համար ընտրել և ինտեգրել ոչ թե պարզապես սարքավորումներ, այլ արդյունավետ, հուսալի և երկարաժամկետ տեխնոլոգիական լուծումներ։',
        partnersApproachTitle: 'Մեր գործընկերային մոտեցումը',
        partnersApproachText: 'Մենք համագործակցում ենք տարբեր երկրների մասնագիտացված ընկերությունների հետ՝ յուրաքանչյուր նախագծի համար ընտրելով տեխնոլոգիան՝ ըստ իրական խնդրի, ջրի կամ կեղտաջրի կազմի, պահանջվող հզորության և շահագործման պայմանների։ NWTA-ն հանդիսանում է կապող օղակ միջազգային տեխնոլոգիայի և Հայաստանում դրա արդյունավետ իրականացման միջև։',
        partnersSubtitle: 'Միջազգային առաջատար ընկերություններ, որոնց հետ համագործակցում ենք',
        partnerType1: 'Ջրի տեխնոլոգիաների գործընկեր',
        partnerType2: 'Էկոլոգիական համակարգեր',
        partnerType3: 'Արդյունաբերական կեղտաջրերի լուծումներ',
        partnerType4: 'Մաքրման կայաններ',
        partnerType5: 'Ինժեներություն և սարքավորումներ',

        // --- НОВОСТИ (БЛОГ) ---
        newsSubtitle: 'Հետևեք NWTA-ի գործունեությանը, նոր նախագծերին, միջազգային համագործակցությանը և ջրային տեխնոլոգիաների ոլորտի կարևոր զարգացումներին։',
        posts: [
            {
                title: 'Արդյունաբերական կեղտաջրեր․ թաքնված բնապահպանական խնդիր',
                date: 'Մարտ 2026',
                desc: 'Անբավարար մաքրված արդյունաբերական կեղտաջրերը կարող են լուրջ վտանգ ներկայացնել գետերի, հողի և ստորերկրյա ջրերի համար՝ վնասելով էկոհամակարգերին և ջրային ռեսուրսների որակին։ Արդյունավետ լուծումը սկսվում է կեղտաջրերի կազմի ճշգրիտ վերլուծությունից, աղտոտիչների բացահայտումից և տվյալ արտադրությանը համապատասխան մաքրման տեխնոլոգիայի ընտրությունից',
                image: news1
            },
            {
                title: 'Չմաքրված կեղտաջրեր․ խնդիր փոքր բնակավայրերի համար',
                date: 'Փետրվար 2026',
                desc: `Հայաստանի բազմաթիվ փոքր քաղաքներում և բնակավայրերում կեղտաջրերի արդյունավետ մաքրումը շարունակում է մնալ կարևոր բնապահպանական և ենթակառուցվածքային խնդիր։ Կենտրոնացված մաքրման համակարգերի բացակայության կամ անբավարար աշխատանքի դեպքում կենցաղային կեղտաջրերը կարող են հայտնվել շրջակա միջավայրում՝ աղտոտելով հողը, ստորերկրյա ջրերը, գետերն ու այլ բնական ջրային ռեսուրսները։
                        Այս խնդրի լուծումը միշտ չէ, որ պահանջում է խոշոր և թանկ կենտրոնացված մաքրման կայանի կառուցում։ Ժամանակակից լոկալ և մոդուլային տեխնոլոգիաները հնարավորություն են տալիս ստեղծել մաքրման համակարգեր առանձին բնակավայրերի, թաղամասերի կամ նոր կառուցապատվող տարածքների համար։
                        Նման համակարգերը կարող են նախագծվել ըստ բնակչության թվի, կեղտաջրերի իրական ծավալի և տեղանքի առանձնահատկությունների՝ ապահովելով կենսաբանական մաքրում, ախտահանում և անհրաժեշտության դեպքում մաքրված ջրի կրկնակի օգտագործում։
                        Ապակենտրոնացված մոտեցումը հնարավորություն է տալիս խնդիրը լուծել փուլային՝ մաքրումը կազմակերպելով հենց կեղտաջրերի առաջացման վայրին մոտ և նվազեցնելով շրջակա միջավայրի վրա ազդեցությունը`,
                image: news2
            },
            {
                title: 'Մաքրման կայաններ․ ժամանակակից ենթակառուցվածքների անհրաժեշտություն',
                date: 'Հունվար 2026',
                desc: `Կեղտաջրերի մաքրման կայանները քաղաքների և բնակավայրերի կարևորագույն ենթակառուցվածքներից են։ Դրանց բացակայությունը, անբավարար հզորությունը կամ տեխնոլոգիական հնացումը կարող են հանգեցնել չմաքրված կամ ոչ բավարար մաքրված կեղտաջրերի արտահոսքի դեպի շրջակա միջավայր։
                        Ժամանակակից մաքրման համակարգերը հնարավորություն են տալիս ոչ միայն նվազեցնել օրգանական և այլ աղտոտիչների պարունակությունը, այլև իրականացնել ջրի ախտահանում, ավտոմատ վերահսկողություն և անհրաժեշտության դեպքում՝ մաքրված ջրի կրկնակի օգտագործում։
                        Յուրաքանչյուր բնակավայրի համար լուծումը պետք է ընտրվի անհատապես՝ հաշվի առնելով բնակչության թիվը, կեղտաջրերի ծավալը, տարածքի առանձնահատկությունները և մաքրված ջրի նկատմամբ սահմանված պահանջները։ Խոշոր կենտրոնացված կայանների հետ մեկտեղ ժամանակակից մոդուլային և ապակենտրոնացված համակարգերը հնարավորություն են տալիս խնդիրը լուծել նաև փուլային և տեղային եղանակով։
                        Ժամանակակից մաքրման կայանը պարզապես ենթակառուցվածք չէ․ այն ներդրում է մաքուր ջրի, առողջ շրջակա միջավայրի և համայնքի կայուն զարգացման մեջ։`,
                image: news3
            }
        ],
        blogReadMore: 'Կարդալ ավելին',
        blogViewAll: 'Դիտել բոլոր նորությունները',
        backButton: 'Վերադառնալ',
        allNewsTitle: 'Բոլոր նորությունները',
        unitingTitle: 'Մենք միավորում ենք',
        unitingItems: [
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>`,
                title: 'Արտադրողներ',
                desc: 'Ջրի և կեղտաջրերի մաքրման մասնագիտացված սարքավորումներ։'
            },
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="8"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/></svg>`,
                title: 'Տեխնոլոգիական ընկերություններ',
                desc: 'Կենսաբանական, մեմբրանային, ֆիզիկաքիմիական և այլ առաջատար տեխնոլոգիաներ։'
            },
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>`,
                title: 'Ինժեներական ընկերություններ',
                desc: 'Բարդ և խոշոր նախագծերի համատեղ նախագծում և իրականացում։'
            },
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
                title: 'Տեղական մասնագետներ',
                desc: 'Տեղադրում, գործարկում, սպասարկում և տեխնիկական աջակցություն Հայաստանում։'
            }
        ],
        projectsTitle: 'Նախագծեր և լուծումներ',
        projectsSubtitle: 'Ինժեներական լուծումներ ջրի և ժամանակակից ենթակառուցվածքների համար',
        projectCategories: [
            { label: 'Բոլորը', value: 'All' },
            { label: ' Համայնքային', value: 'Municipal' },
            { label: ' Արդյունաբերական', value: 'Industrial' },
            { label: ' Հյուրանոցներ', value: 'Hotels' },
            { label: ' Բնակելի', value: 'Residential' },
            { label: ' Սանիտարական', value: 'Sanitary' },
        ],
        projects: [
            {
                title: 'ԲՆԱԿԱՎԱՅՐԵՐԻ ԿԵՂՏԱՋՐԵՐԻ ՄԱՔՐՈՒՄ',
                category: 'Municipal',
                image: 'img1',
                desc: 'Ժամանակակից մոդուլային և ապակենտրոնացված մաքրման համակարգեր քաղաքների և համայնքների համար։'
            },
            {
                title: 'ԱՐԴՅՈՒՆԱԲԵՐԱԿԱՆ ԿԵՂՏԱՋՐԵՐԻ ՄԱՔՐՈՒՄ',
                category: 'Industrial',
                image: 'img2',
                desc: 'Արդյունաբերական կեղտաջրերի մաքրման համալիր լուծումներ՝ յուրաքանչյուր արտադրության առանձնահատկություններին համապատասխան։'
            },
            {
                title: 'ՀՅՈՒՐԱՆՈՑՆԵՐԻ ԵՎ ԶԲՈՍԱՇՐՋԱՅԻՆ ՀԱՄԱԼԻՐՆԵՐԻ ԿԵՂՏԱՋՐԵՐԻ ՄԱՔՐՈՒՄ',
                category: 'Hotels',
                image: 'img3',
                desc: 'Կոմպակտ և անաղմուկ լուծում բարձրակարգ հյուրանոցների և հանգստյան գոտիների համար:'
            },
            {
                title: 'ԼՈԿԱԼ ՄԱՔՐՄԱՆ ՀԱՄԱԿԱՐԳԵՐ ԲՆԱԿԵԼԻ ՀԱՄԱԼԻՐՆԵՐԻ ՀԱՄԱՐ',
                category: 'Residential',
                image: 'img4',
                desc: 'Կոմպակտ և ավտոմատացված կեղտաջրերի մաքրման համակարգեր բնակելի համալիրների և նոր կառուցապատումների համար։'
            },
            {
                title: 'ՋՐԱՊԱՏՐԱՍՏՈՒՄ ԵՎ ՋՐԻ ԿՐԿՆԱԿԻ ՕԳՏԱԳՈՐԾՈՒՄ',
                category: 'Sanitary',
                image: 'img5',
                desc: 'Ջրի մաքրման, վերամշակման և կրկնակի օգտագործման ժամանակակից համակարգեր՝ ջրային ռեսուրսների արդյունավետ օգտագործման համար'
            },
            {
                title: 'ԺԱՄԱՆԱԿԱԿԻՑ ՍԱՆԻՏԱՐԱԿԱՆ ԵՆԹԱԿԱՌՈՒՑՎԱԾՔՆԵՐ',
                category: 'Municipal',
                image: 'img6',
                desc: 'Ժամանակակից ավտոմատացված սանիտարական լուծումներ քաղաքների, զբոսաշրջային գոտիների և հանրային տարածքների համար։'
            }
        ],

        timelineTitle: 'Ծառայություններ',
        timelineSubtitle: 'Ջրային և բնապահպանական նախագծերի իրականացման ամբողջական ցիկլ՝ օբյեկտի ուսումնասիրությունից մինչև տեխնիկական սպասարկում:',
        servicesSteps: [
            { num: '01', title: ' Օբյեկտի ուսումնասիրություն և վերլուծություն', desc: 'Այց օբյեկտ, ելակետային տվյալների, ջրի և կեղտաջրերի վերլուծություն, տեխնիկական պահանջների սահմանում։', image: service1 },
            { num: '02', title: 'Ինժեներական նախագծում', desc: 'Տեխնոլոգիական սխեմայի մշակում, անհրաժեշտ հզորության հաշվարկ և նախագծային լուծումների մշակում։', image: service2 },
            { num: '03', title: 'Տեխնոլոգիայի և սարքավորումների ընտրություն', desc: 'Յուրաքանչյուր օբյեկտի համար օպտիմալ տեխնոլոգիայի և համապատասխան սարքավորումների ընտրություն։', image: service3 },
            { num: '04', title: 'Սարքավորումների մատակարարում', desc: 'Նախագծի համալրում, լոգիստիկայի կազմակերպում և սարքավորումների մատակարարում օբյեկտ։', image: service4 },
            { num: '05', title: 'Մոնտաժ և գործարկում', desc: 'Համակարգերի տեղադրում, միացում, ավտոմատիկայի կարգավորում և համակարգի գործարկում։', image: service5 },
            { num: '06', title: 'Սպասարկում և տեխնիկական աջակցություն', desc: 'Ստուգում, կարգավորում և պարամետրերի ճշգրտում', image: service6 },
            { num: '07', title: 'Սպասարկում', desc: 'Պարբերական սպասարկում, աշխատանքի վերահսկում, արդիականացում և տեխնիկական աջակցություն։', image: service7 }
        ],

        // --- КОНТАКТЫ ---
        contactTitle: 'Կապ',
        contactHeading: 'Եկեք քննարկենք Ձեր նախագիծը',
        contactIntro: 'Ունե՞ք ջրի կամ կեղտաջրերի մաքրման խնդիր, նախատեսում եք նոր նախագիծ կամ փնտրում եք համապատասխան տեխնոլոգիական լուծում։ NWTA-ի թիմը պատրաստ է ուսումնասիրել Ձեր խնդիրը և առաջարկել արդյունավետ ինժեներական լուծում։',
        companyName: 'National Water Technologies Armenia LLC',
        contactAddressLabel: 'Հասցե',
        contactPhoneLabel: 'Հեռախոս',
        contactEmailLabel: 'Email',
        contactFormTitle: 'Ուղարկեք մեզ Ձեր հարցումը',
        contactFormSubtitle: 'Կապվեք մեզ հետ՝ ներկայացնելով նախագծի վերաբերյալ հիմնական տեղեկատվությունը։',
        contactLabelName: 'Անուն / Ազգանուն',
        contactLabelCompany: 'Ընկերություն / Կազմակերպություն',
        contactLabelPhone: 'Հեռախոս',
        contactLabelEmail: 'Էլ. փոստ',
        contactLabelProjectType: 'Նախագծի տեսակը',
        contactSelectProject: 'Ընտրեք նախագծի տեսակը',
        contactOptMunicipal: 'Համայնքային կեղտաջրերի մաքրում',
        contactOptIndustrial: 'Արդյունաբերական կեղտաջրերի մաքրում',
        contactOptDrinking: 'Խմելու ջրի մաքրում',
        contactOptLocal: 'Տեղային մաքրման կայան',
        contactOptOther: 'Այլ',
        contactLabelMessage: 'Հաղորդագրություն',
        contactButtonSend: 'Ուղարկել հարցումը',
        contactSentSuccess: 'Հաղորդագրությունը հաջողությամբ ուղարկվեց։',
        contactCooperationTitle: 'Համագործակցության համար',
        contactCooperationText: 'Մենք բաց ենք համագործակցության համար պետական և համայնքային կառույցների, մասնավոր ընկերությունների, կառուցապատողների, արդյունաբերական ձեռնարկությունների, ինժեներական կազմակերպությունների և միջազգային տեխնոլոգիական գործընկերների հետ։',
        contactCooperationTagline: 'Սկսենք խնդրից։ Գտնենք ճիշտ լուծումը։ Իրականացնենք միասին։',

        waterclean: {
            badge: "WaterClean",
            title: "ԽՄԵԼՈՒ ՋՐԻ ՄԱՔՐՈՒՄ ԵՎ ՋՐԱՊԱՏՐԱՍՏՈՒՄ",
            description: "NWTA-ն առաջարկում է խմելու ջրի մաքրման ժամանակակից լուծումներ բնակելի, առևտրային և հասարակական օբյեկտների համար՝ ջրի որակի վերլուծությունից մինչև սարքավորումների ընտրություն, տեղադրում և սպասարկում։",
            quote: "Մաքուր ջուրը սկսվում է ճիշտ լուծումից NWTA-ն օգնում է ընտրել ջրի մաքրման համակարգ՝ հիմնված ջրի իրական որակի, սպառման ծավալի և օբյեկտի պահանջների վրա",


            services: [
                {
                    title: "Խմելու ջրի ֆիլտրացիա",
                    description: "Մաքուր և անվտանգ ջուր ամենօրյա օգտագործման համար։",
                },
                {
                    title: "Հակադարձ օսմոս",
                    description: "Ջրի խորը մաքրում և անցանկալի խառնուրդների հեռացում։",
                },
                {
                    title: "Ջրի փափկեցում",
                    description: "Կոշտության նվազեցում և սարքավորումների պաշտպանություն կրաքարից։",
                },
                {
                    title: "Համալիր ջրապատրաստում",
                    description: "Երկաթի, մեխանիկական խառնուրդների, հոտի և այլ աղտոտիչների հեռացում։",
                },
                {
                    title: "Պուրիֆայերներ և դիսպենսերներ",
                    description: "Խմելու ջրի ժամանակակից լուծումներ գրասենյակների, դպրոցների, հյուրանոցների և հանրային տարածքների համար։",
                },
            ],
        },
    },

    // ***************************************************************************************
    // ************************************* ENGLISH *****************************************
    // ***************************************************************************************
    ENG: {
        // --- NAVIGATION (UPDATED) ---
        homeLink: 'Home',
        aboutTitle: 'About us',
        challengesTitle: 'Challenges',
        problemsTitle: 'Problems', // Было timelineTitle
        solutionsTitle: 'Solutions',
        industriesTitle: 'Industries', // Было blogTitle
        technologiesTitle: 'Technologies', // Новое
        partnersTitle: 'Partners',
        projectsTitle: 'Projects', // Новое
        newsTitle: 'NEWS AND ANALYSIS', // Новое
        contactTitle: 'Contact',
        quickMenu: 'Quick menu',
        socialTitle: 'Social links',

        // --- FOOTER ---
        footerCompanyName: 'National Water Technologies Armenia LLC',
        footerAddress: 'Yerevan, Armenia',
        footerPhone: '+37495040655',
        footerEmail: 'nwt.arm@gmail.com',
        footerRights: '© 2026 NWTA. All rights reserved.',
        footerTagline: 'International engineering standard',
        footerRights: '© 2026 NWTA. All rights reserved.',
        websitetext1: " Website developed by",
        websitetext2: "programming center.",
        // --- HERO ---
        heroBadge: 'WATER TECHNOLOGIES AND MODERN INFRASTRUCTURE',
        heroTitle: 'NATIONAL WATER',
        heroTitle2: 'TECHNOLOGIES INTEGRATOR OF ARMENIA',
        heroText: 'Modern solutions for water treatment, wastewater treatment and reuse', 
        btnSolutions: 'Contact a specialist',
        btnContact: 'Find a solution',

        directions: [
            "Water treatment and preparation",
            "Wastewater treatment and reuse",
            "Industrial water solutions",
            "Municipal and urban infrastructure"
        ],
        directionsTitle: "Our main directions",
        // --- ABOUT (UPDATED TEXT) ---
        aboutFocusTitle: 'Building Armenia’s water future',
        aboutFocusText: 'National Water Technologies Armenia (NWTA) is a national engineering company that combines leading international technologies and professional expertise to develop Armenia’s water infrastructure. We believe that clean water, a safe environment, and modern engineering solutions are the foundation of the country’s sustainable development.',
        aboutWhatSetsUsApart: 'What sets us apart',
        aboutHighlights: [
            'Tailored approach for every project',
            'Technical and environmental assessment',
            'Integration of international experience with local needs',
            'Proven track record of completed projects',
            'End-to-end equipment and service delivery'
        ],
        aboutIcons: ['Design', 'Implementation', 'Support'],

        approachTitle: 'Our approach',
        approachSubtitle: 'We do not simply sell equipment',
        approachDesc: 'We study the specific needs of each project, assess technical and environmental requirements, and offer solutions that deliver efficiency, reliability and long-term value.',

        whatWeDoTitle: 'What we do',
        whatWeDoIntro: 'NWTA delivers complete engineering projects for:',
        whatWeDoServices: [
            'Municipal wastewater treatment systems',
            'Industrial wastewater treatment',
            'Drinking water purification systems',
            'Decentralized biological treatment plants',
            'Water reuse solutions',
            'Modern public sanitation systems',
            'Engineering design and technical consulting',
            'Equipment supply, installation and maintenance'
        ],
        whatWeDoGoalTitle: 'Our goal is clear',
        whatWeDoGoalText: 'To create a cleaner, safer and more technologically advanced Armenia through modern water solutions.',
        whatWeDoMissionTitle: 'Our mission',
        whatWeDoMissionText: 'To create modern, reliable and sustainable water solutions that improve quality of life, protect natural resources and support economic and environmental development.',

        // --- PROBLEMS (NEW PAGE) ---
        problemsMainTitle: 'Armenia’s water challenges',
        problemsMainDesc: 'Water is one of our most precious natural resources. However, the development of water infrastructure requires modern and efficient solutions.',
        problemsList: [
            {

                title: 'Inadequate wastewater treatment',
                desc: 'Untreated or insufficiently treated wastewater can pollute rivers, lakes and groundwater.'
            },
            {

                title: 'Industrial pollution',
                desc: 'Industrial wastewater often requires special treatment technologies to comply with environmental standards.'
            },
            {

                title: 'Drinking water quality',
                desc: 'Maintaining water quality is critical for public health and safe water supply.'
            },
            {

                title: 'New residential districts',
                desc: 'Many newly developed areas lack adequate water infrastructure.'
            }
        ],
        problemsVisionLabel: "Our vision",
        problemsVisionHeading: "Every problem has its solution.",
        problemsVisionText: "NWTA offers modern, efficient and long-term engineering solutions tailored to the requirements of each project.",
        problemsVisionFooter: "Clean water. Modern technologies. Sustainable future.",
        // --- SOLUTIONS ---
        solutionsPageTitle: 'Solutions',
        solutionsSubtitle: 'Modern water solutions for Armenia',
        solutionsDesc: 'NWTA offers complete engineering solutions in water supply, wastewater treatment and water infrastructure development.',
        solutionsTabs: [
            {
                id: 'municipal',
                title: 'Municipal wastewater treatment',
                desc: 'Modern treatment plants for cities, communities and settlements.',
                image: lucum1,
                items: ['Biological treatment', 'Mechanical treatment', 'Sludge processing', 'Odor control', 'Automation systems']
            },
            {
                id: 'industrial',
                title: 'Industrial wastewater treatment',
                desc: 'Solutions for various industrial sectors.',
                image: lucum2,
                items: ['Food industry', 'Winemaking', 'Dairy production', 'Metal processing', 'Car wash stations', 'Mining', 'Chemical production']
            },
            {
                id: 'drinking',
                title: 'Water treatment and purification',
                desc: 'We offer modern technologies for safe water purification.',
                image: lucum3,
                items: ['Filtration', 'UV disinfection', 'Membrane systems', 'Activated carbon filters', 'Water quality monitoring']
            },
            {
                id: 'local',
                title: 'Decentralized treatment plants',
                desc: 'Solutions for different types of facilities.',
                image: lucum4,
                items: ['Private houses', 'Residential complexes', 'Hotels', 'Schools', 'Kindergartens', 'Sanatoriums', 'Recreation areas']
            },
            {
                id: 'sanitary',
                title: 'Modern public sanitation systems',
                desc: 'Self-cleaning public restrooms and smart systems.',
                image: lucum5,
                items: ['Modular solutions', 'Smart management systems', 'Accessibility for people with reduced mobility', 'Energy-efficient operation']
            },
            {
                id: 'reuse',
                title: 'Water reuse',
                desc: 'Using treated water for various purposes.',
                image: lucum6,
                items: ['Irrigation', 'Landscape maintenance', 'Technical processes', 'Industrial use']
            }
        ],
        principleTitle: 'Our principle',
        principleText: 'We offer not only equipment, but complete, efficient and long-term solutions tailored to every project.',
        principleHeading: '“One partner for the full solution”',
        principleStep1: 'Analysis',
        principleStep2: 'Design',
        principleStep3: 'Technology',
        principleStep4: 'Implementation',
        principleStep5: 'Maintenance',

        // --- INDUSTRIES ---
        industriesPageTitle: 'Industries',
        industriesSubtitle: 'Solutions for every sector',
        industriesDesc: 'Each sector has its own characteristics, requirements and environmental challenges. NWTA designs and implements solutions considering the technical and operational needs of each site.',
        industries: [
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M7 17V9"/><path d="M12 17V5"/><path d="M17 17v-7"/></svg>',
                title: 'Communities and Cities',
                desc: 'Water supply, wastewater collection, and treatment systems for settlements.',
                items: ['Urban Infrastructure', 'Municipal Plants', 'Treatment Facilities', 'Automated Control'],
                image: 'https://mywikis-wiki-media.s3.us-central-1.wasabisys.com/armeniapedia/Square_From_Above.jpg'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18"/><path d="M8 4v16"/></svg>',
                title: 'Industry',
                desc: 'High-efficiency, technologically advanced solutions for production facilities.',
                items: ['Food Industry', 'Winemaking', 'Dairy Production', 'Chemical Industry'],
                image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnZI9LFArzKkditu531-EERiRrq1fQd9xqEdVTPMzuMNcfV6vNW0ZlS4hS&s=10'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Hotels and Tourism',
                desc: 'Comfortable, safe, and sustainable water solutions for the hospitality and public sectors.',
                items: ['Hotels', 'Resorts', 'Recreation Areas', 'Tourist Complexes'],
                image: 'https://greenrock.am/wp-content/uploads/2025/08/04-1-1-768x618.jpg'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Residential Complexes',
                desc: 'Reliable water supply and drainage engineering systems for modern residential areas.',
                items: ['Multi-apartment Buildings', 'Cottage Settlements', 'Residential Districts', 'Management Companies'],
                image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqbdLJvPXMqaZgkTuI2hL61ZORowlzGZU1zlkmBVHxiphnm0sDGmUW604&s=10'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Agriculture',
                desc: 'Efficient solutions for irrigation, water treatment, and wastewater management in the agricultural sector.',
                items: ['Greenhouses', 'Irrigation Systems', 'Agricultural Complexes', 'Farms'],
                image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReZu8Lousi9d6e-JKUws1I8wePKtTWAeIOrNvohIctZBw_mj2P7P-F-fET&s=10'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Food industry and beverage production',
                desc: 'Specialized water treatment and purification systems for food and beverage production.',
                items: ['Water Bottling Plants', 'Brewing', 'Juice Production', 'Food Processing Plants'],
                image: 'https://loyalmachines.com/wp-content/uploads/2024/10/a-2-2.png'
            }
        ],
        whyTitle: "WHY CHOOSE NWTA",
        whyItems: [
            "Integration of global technologies",
            "Custom engineering solutions",
            "One partner — from design to maintenance",
            "Solutions adapted to local conditions",
            "Modern and energy-efficient technologies",
            "Long-term technical support"
        ],
        whyMissionTitle: "Our mission",
        whyMissionText: "To provide Armenia with modern water technologies, creating a clean, safe and sustainable environment for future generations.",
        // --- PARTNERS ---
        partnersPageTitle: 'Partners',
        partnersTitle: 'International Technologies. Local Expertise. One Common Goal.',
        partnersDesc: 'National Water Technologies Armenia (NWTA) develops an international cooperation network by bringing together leading manufacturers, engineering companies and technology partners in the water sector. Our goal is to select and integrate not just equipment, but efficient, reliable and long-term technological solutions for Armenia.',
        partnersApproachTitle: 'Our Partnership Approach',
        partnersApproachText: 'We collaborate with specialized companies from different countries, selecting technology for each project based on the actual problem, water or wastewater composition, required capacity and operating conditions. NWTA serves as the bridge between international technology and its effective implementation in Armenia.',
        partnersSubtitle: 'Leading international companies we collaborate with',
        partnerType1: 'Water Technology Partner',
        partnerType2: 'Ecology Systems',
        partnerType3: 'Industrial Wastewater Solutions',
        partnerType4: 'Treatment Plants',
        partnerType5: 'Engineering & Equipment',

        // --- NEWS (BLOG) ---
        newsSubtitle: 'Follow NWTA activities, new projects, international cooperation and important developments in the field of water technologies.',
        posts: [
            {
                title: 'Advanced automation for treatment plants',
                date: 'March 2026',
                desc: 'How smart sensors improve efficiency and reduce costs.',
                image: news1
            },
            {
                title: 'New water reuse strategies',
                date: 'February 2026',
                desc: 'How organizations can control water demand and reduce losses.',
                image: news2
            },
            {
                title: 'Compliance with environmental requirements',
                date: 'January 2026',
                desc: 'Effective solutions for meeting environmental standards.',
                image: news3
            }
        ],
        blogReadMore: 'Read more',
        blogViewAll: 'View all news',
        backButton: 'Back',
        allNewsTitle: 'All News',
        unitingTitle: 'We Bring Together',
        unitingItems: [
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>`,
                title: 'Manufacturers',
                desc: 'Specialized water and wastewater treatment equipment.'
            },
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="8"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/></svg>`,
                title: 'Technology Companies',
                desc: 'Biological, membrane, physicochemical and other leading technologies.'
            },
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>`,
                title: 'Engineering Companies',
                desc: 'Joint design and implementation of complex and large-scale projects.'
            },
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
                title: 'Local Specialists',
                desc: 'Installation, commissioning, maintenance and technical support in Armenia.'
            }
        ],

        projectsTitle: 'PROJECTS AND SOLUTIONS',
        projectsSubtitle: 'Engineering solutions for water and modern infrastructure',
        projectCategories: [
            { label: 'All', value: 'All' },
            { label: ' Municipal', value: 'Municipal' },
            { label: ' Industrial', value: 'Industrial' },
            { label: ' Hotels', value: 'Hotels' },
            { label: 'Residential', value: 'Residential' },
            { label: 'Sanitary', value: 'Sanitary' },
        ],
        projects: [
            {
                title: 'MUNICIPAL WASTEWATER TREATMENT',
                category: 'Municipal',
                image: 'img1',
                desc: 'Modern modular and decentralized treatment systems for cities and communities.'
            },
            {
                title: 'INDUSTRIAL WASTEWATER TREATMENT',
                category: 'Industrial',
                image: 'img2',
                desc: 'Comprehensive industrial wastewater treatment solutions tailored to the specifics of each production facility.'
            },
            {
                title: 'WASTEWATER TREATMENT FOR HOTELS AND TOURIST COMPLEXES',
                category: 'Hotels',
                image: 'img3',
                desc: 'Compact and silent solutions for premium hotels and recreational areas.'
            },
            {
                title: 'LOCAL TREATMENT SYSTEMS FOR RESIDENTIAL COMPLEXES',
                category: 'Residential',
                image: 'img4',
                desc: 'Compact and automated wastewater treatment systems for residential complexes and new developments.'
            },
            {
                title: 'WATER TREATMENT AND REUSE',
                category: 'Sanitary',
                image: 'img5',
                desc: 'Modern systems for water purification, treatment and reuse for efficient water resource management.'
            },
            {
                title: 'MODERN SANITARY INFRASTRUCTURE',
                category: 'Municipal',
                image: 'img6',
                desc: 'Modern automated sanitary solutions for cities, tourist areas and public spaces.'
            }
        ],
        timelineTitle: 'Services',
        timelineSubtitle: 'A complete cycle of water and environmental project implementation — from site survey to technical maintenance.',
        servicesSteps: [
            { num: '01', title: 'Site survey and analysis', desc: 'Site visit, baseline data collection, water and wastewater analysis, definition of technical requirements.', image: service1 },
            { num: '02', title: 'Engineering design', desc: 'Development of process flow diagram, calculation of required capacity and design solutions.', image: service2 },
            { num: '03', title: 'Technology and equipment selection', desc: 'Selection of the optimal technology and suitable equipment for each facility.', image: service3 },
            { num: '04', title: 'Equipment supply', desc: 'Project procurement, logistics organization and delivery of equipment to the site.', image: service4 },
            { num: '05', title: 'Installation and commissioning', desc: 'System installation, connection, automation setup and system start-up.', image: service5 },
            { num: '06', title: 'Maintenance and technical support', desc: 'Inspection, adjustment and parameter fine-tuning.', image: service6 },
            { num: '07', title: 'Service', desc: 'Periodic maintenance, performance monitoring, modernization and technical support.', image: service7 }
        ],
        // --- CONTACT ---
        contactTitle: 'Contact',
        contactHeading: 'Let\'s discuss your project',
        contactIntro: 'Do you have a water or wastewater treatment problem, planning a new project or looking for a suitable technological solution? The NWTA team is ready to study your problem and offer an effective engineering solution.',
        companyName: 'National Water Technologies Armenia LLC',
        contactAddressLabel: 'Address',
        contactPhoneLabel: 'Phone',
        contactEmailLabel: 'Email',
        contactFormTitle: 'Send us your inquiry',
        contactFormSubtitle: 'Contact us by providing basic project information.',
        contactLabelName: 'First Name / Last Name',
        contactLabelCompany: 'Company / Organization',
        contactLabelPhone: 'Phone',
        contactLabelEmail: 'Email',
        contactLabelProjectType: 'Project Type',
        contactSelectProject: 'Select project type',
        contactOptMunicipal: 'Municipal wastewater treatment',
        contactOptIndustrial: 'Industrial wastewater treatment',
        contactOptDrinking: 'Drinking water purification',
        contactOptLocal: 'Local treatment plant',
        contactOptOther: 'Other',
        contactLabelMessage: 'Message',
        contactPlaceholderName: 'Your name',
        contactPlaceholderEmail: 'example@mail.com',
        contactPlaceholderPhone: '+374 XX XXXXXX',
        contactPlaceholderMessage: 'Write your message...',
        contactButtonSend: 'Send inquiry',
        contactSentSuccess: 'Your message has been sent successfully.',
        contactCooperationTitle: 'For cooperation',
        contactCooperationText: 'We are open for cooperation with state and municipal bodies, private companies, developers, industrial enterprises, engineering organizations and international technology partners.',
        contactCooperationTagline: 'Let\'s start with the problem. Find the right solution. Implement together.',

        waterclean: {
            badge: "WaterClean",
            title: "DRINKING WATER PURIFICATION AND TREATMENT",
            description: "NWTA offers modern drinking water purification solutions...",
            quote: "Clean water starts with the right solution",
            quoteSub: "NWTA helps you choose a water treatment system...",


            services: [
                {
                    title: "Drinking Water Filtration",
                    description: "Clean and safe water for daily use.",
                },
                {
                    title: "Reverse Osmosis",
                    description: "Deep water purification and removal of unwanted impurities.",
                },
                {
                    title: "Water Softening",
                    description: "Hardness reduction and equipment protection from limescale.",
                },
                {
                    title: "Complex Water Treatment",
                    description: "Removal of iron, mechanical impurities, odor and other contaminants.",
                },
                {
                    title: "Purifiers and Dispensers",
                    description: "Modern drinking water solutions for offices, schools, hotels and public spaces.",
                },
            ],
        },
    },

    // ***************************************************************************************
    // ************************************* РУССКИЙ ****************************************
    // ***************************************************************************************
    RU: {
        // --- НАВИГАЦИЯ (ОБНОВЛЕНО) ---
        homeLink: 'Главная',
        aboutTitle: 'О компании',
        challengesTitle: 'Проблемы',
        problemsTitle: 'Проблемы', // Было timelineTitle
        solutionsTitle: 'Решения',
        industriesTitle: 'Отрасли', // Было blogTitle
        technologiesTitle: 'Технологии', // Новое
        partnersTitle: 'Партнеры',
        projectsTitle: 'Проекты', // Новое
        newsTitle: 'НОВОСТИ И АНАЛИТИКА', // Новое
        contactTitle: 'Контакты',
        quickMenu: 'Быстрое меню',
        socialTitle: 'Социальные сети',

        // --- ПОДВАЛ (FOOTER) ---
        footerCompanyName: 'National Water Technologies Armenia LLC',
        footerAddress: 'Ереван, Армения',
        footerPhone: '+37495040655',
        footerEmail: 'nwt.arm@gmail.com',
        footerRights: '© 2026 NWTA. Все права защищены.',
        footerTagline: 'Международный инженерный стандарт',
        footerRights: '© 2026 NWTA. Все права защищены.',

        heroBadge: 'ВОДНЫЕ ТЕХНОЛОГИИ И СОВРЕМЕННАЯ ИНФРАСТРУКТУРА', heroTitle: 'НАЦИОНАЛЬНЫЙ',
        heroTitle2: 'ИНТЕГРАТОР ВОДНЫХ ТЕХНОЛОГИЙ АРМЕНИИ',
        heroText: 'Современные решения для очистки воды, очистки сточных вод и повторного использования',
        btnSolutions: 'Связаться со специалистом',
        btnContact: 'Подобрать решение',
        websitetext1: " Сайт разработан",
        websitetext2: "учебным центром программирования.",
        directions: [
            "Очистка и подготовка воды",
            "Очистка и повторное использование сточных вод",
            "Промышленные водные решения",
            "Муниципальная и городская инфраструктура"
        ],
        directionsTitle: "Наши основные направления",
        // --- О НАС (ОБНОВЛЕННЫЙ ТЕКСТ) ---
        aboutFocusTitle: 'Мы строим водное будущее Армении',
        aboutFocusText: 'National Water Technologies Armenia (NWTA) — национальная инженерная компания, объединяющая передовые международные технологии и профессиональный опыт для развития водной инфраструктуры Армении. Мы верим, что чистая вода, безопасная окружающая среда и современные инженерные решения — основа устойчивого развития страны.',
        aboutWhatSetsUsApart: 'Что отличает нас',
        aboutHighlights: [
            'Индивидуальный подход к каждому проекту',
            'Техническая и экологическая оценка',
            'Интеграция международного опыта с локальными потребностями',
            'Проверенный опыт реализованных проектов',
            'Полный цикл поставки оборудования и сервисного сопровождения'
        ],
        aboutIcons: ['Проектирование', 'Реализация', 'Поддержка'],

        approachTitle: 'Наш подход',
        approachSubtitle: 'Мы не просто продаем оборудование',
        approachDesc: 'Мы изучаем особенности каждого проекта, оцениваем технические и экологические требования и предлагаем решения, обеспечивающие эффективность, надежность и долгосрочный результат.',

        whatWeDoTitle: 'Чем мы занимаемся',
        whatWeDoIntro: 'NWTA реализует комплексные инженерные проекты для:',
        whatWeDoServices: [
            'Муниципальные системы очистки сточных вод',
            'Очистка промышленных сточных вод',
            'Системы очистки питьевой воды',
            'Местные биологические очистные станции',
            'Решения по повторному использованию воды',
            'Современные общественные санитарные системы',
            'Инженерное проектирование и технические консультации',
            'Поставка, монтаж и обслуживание оборудования'
        ],
        whatWeDoGoalTitle: 'Наша цель проста',
        whatWeDoGoalText: 'Создавать более чистую, безопасную и технологически развитую Армению с помощью современных водных решений.',
        whatWeDoMissionTitle: 'Наша миссия',
        whatWeDoMissionText: 'Создавать современные, надежные и устойчивые водные решения, улучшающие качество жизни, защищающие природные ресурсы и способствующие экономическому и экологическому развитию.',

        // --- ПРОБЛЕМЫ (НОВАЯ СТРАНИЦА) ---
        problemsMainTitle: 'Водные вызовы Армении',
        problemsMainDesc: 'Вода — один из наших самых ценных природных ресурсов. Однако развитие водной инфраструктуры требует современных и эффективных решений.',
        problemsList: [
            {

                title: 'Недостаточная очистка сточных вод',
                desc: 'Неочищенные или недостаточно очищенные сточные воды могут загрязнять реки, озера и подземные воды.'
            },
            {

                title: 'Промышленное загрязнение',
                desc: 'Сточные воды промышленных предприятий часто требуют специальных технологий очистки для соответствия экологическим нормам.'
            },
            {

                title: 'Качество питьевой воды',
                desc: 'Поддержание качества воды имеет решающее значение для здоровья населения и безопасного водоснабжения.'
            },
            {

                title: 'Новые жилые районы',
                desc: 'Многие новые застраиваемые территории не имеют соответствующей водной инфраструктуры.'
            }
        ],
        problemsVisionLabel: "Наше видение",
        problemsVisionHeading: "У каждой проблемы есть своё решение.",
        problemsVisionText: "NWTA предлагает современные, эффективные и долгосрочные инженерные решения, адаптированные под требования каждого проекта.",
        problemsVisionFooter: "Чистая вода. Современные технологии. Устойчивое будущее.",

        // --- РЕШЕНИЯ ---
        solutionsPageTitle: 'Решения',
        solutionsSubtitle: 'Современные водные решения для Армении',
        solutionsDesc: 'NWTA предлагает комплексные инженерные решения в сфере водоснабжения, очистки сточных вод и развития водной инфраструктуры.',
        solutionsTabs: [
            {
                id: 'municipal',
                title: 'Очистка муниципальных сточных вод',
                desc: 'Современные очистные станции для городов, общин и населенных пунктов.',
                image: lucum1,
                items: ['Биологическая очистка', 'Механическая очистка', 'Обработка осадка', 'Контроль запахов', 'Системы автоматизации']
            },
            {
                id: 'industrial',
                title: 'Очистка промышленных сточных вод',
                desc: 'Решения для различных производственных секторов.',
                image: lucum2,
                items: ['Пищевая промышленность', 'Виноделие', 'Молочное производство', 'Металлообработка', 'Автомойки', 'Добыча полезных ископаемых', 'Химическое производство']
            },
            {
                id: 'drinking',
                title: 'Водоподготовка и очистка воды',
                desc: 'Мы предлагаем современные технологии для безопасной очистки воды.',
                image: lucum3,
                items: ['Фильтрация', 'УФ-дезинфекция', 'Мембранные системы', 'Угольные фильтры', 'Мониторинг качества воды']
            },
            {
                id: 'local',
                title: 'Локальные очистные станции',
                desc: 'Решения для различных объектов.',
                image: lucum4,
                items: ['Частные дома', 'Жилые комплексы', 'Отели', 'Школы', 'Детские сады', 'Санатории', 'Зоны отдыха']
            },
            {
                id: 'sanitary',
                title: 'Современные общественные санитарные системы',
                desc: 'Самоочищающиеся общественные туалеты и умные системы.',
                image: lucum5,
                items: ['Модульные решения', 'Умные системы управления', 'Доступность для людей с ограниченной подвижностью', 'Энергоэффективная эксплуатация']
            },
            {
                id: 'reuse',
                title: 'Повторное использование воды',
                desc: 'Использование очищенной воды для различных целей.',
                image: lucum6,
                items: ['Орошение', 'Обслуживание зеленых зон', 'Технические процессы', 'Промышленные нужды']
            }
        ],
        principleTitle: 'Наш принцип',
        principleText: 'Мы предлагаем не только оборудование, но и комплексные, эффективные и долгосрочные решения под каждый проект.',
        principleHeading: '«Один партнер — полное решение»',
        principleStep1: 'Анализ',
        principleStep2: 'Проектирование',
        principleStep3: 'Технология',
        principleStep4: 'Реализация',
        principleStep5: 'Обслуживание',

        // --- ОТРАСЛИ ---
        industriesPageTitle: 'Отрасли',
        industriesSubtitle: 'Решения для каждого сектора',
        industriesDesc: 'Каждая отрасль имеет свои особенности, требования и экологические вызовы. NWTA проектирует и внедряет решения с учетом технических и эксплуатационных потребностей каждого объекта.',
        industries: [
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M7 17V9"/><path d="M12 17V5"/><path d="M17 17v-7"/></svg>',
                title: 'Общины и города',
                desc: 'Системы водоснабжения, сбора и очистки сточных вод для населенных пунктов.',
                items: ['Городская инфраструктура', 'Общинные станции', 'Очистные сооружения', 'Автоматическое управление'],
                image: 'https://mywikis-wiki-media.s3.us-central-1.wasabisys.com/armeniapedia/Square_From_Above.jpg'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18"/><path d="M8 4v16"/></svg>',
                title: 'Промышленность',
                desc: 'Высокоэффективные, технологически развитые решения для производственных объектов.',
                items: ['Пищевая промышленность', 'Виноделие', 'Молочное производство', 'Химическая промышленность'],
                image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnZI9LFArzKkditu531-EERiRrq1fQd9xqEdVTPMzuMNcfV6vNW0ZlS4hS&s=10'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Отели и туризм',
                desc: 'Комфортные, безопасные и устойчивые водные решения для гостиничного и общественного сектора.',
                items: ['Гостиницы', 'Курорты', 'Зоны отдыха', 'Туристические комплексы'],
                image: 'https://greenrock.am/wp-content/uploads/2025/08/04-1-1-768x618.jpg'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Жилые комплексы',
                desc: 'Надежные инженерные системы водоснабжения и водоотведения для современных жилых кварталов.',
                items: ['Многоквартирные дома', 'Коттеджные поселки', 'Жилые кварталы', 'Управляющие компании'],
                image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqbdLJvPXMqaZgkTuI2hL61ZORowlzGZU1zlkmBVHxiphnm0sDGmUW604&s=10'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Сельское хозяйство',
                desc: 'Эффективные решения для орошения, подготовки воды и очистки стоков в агросекторе.',
                items: ['Тепличные хозяйства', 'Системы орошения', 'Агрокомплексы', 'Фермерские хозяйства'],
                image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReZu8Lousi9d6e-JKUws1I8wePKtTWAeIOrNvohIctZBw_mj2P7P-F-fET&s=10'
            },
            {
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M7 20V8"/><path d="M12 20V4"/><path d="M17 20v-6"/></svg>',
                title: 'Пищевая промышленность и производство напитков',
                desc: 'Специализированные системы водоподготовки и очистки для производства напитков и продуктов питания.',
                items: ['Заводы по розливу воды', 'Пивоварение', 'Производство соков', 'Пищевые комбинаты'],
                image: 'https://loyalmachines.com/wp-content/uploads/2024/10/a-2-2.png'
            }
        ],
        whyTitle: "ПОЧЕМУ ВЫБИРАЮТ NWTA",
        whyItems: [
            "Интеграция международных технологий",
            "Индивидуальные инженерные решения",
            "Один партнёр — от проекта до обслуживания",
            "Решения, адаптированные к условиям Армении",
            "Современные и энергоэффективные технологии",
            "Долгосрочная техническая поддержка"
        ],
        whyMissionTitle: "Наша миссия",
        whyMissionText: "Обеспечить Армению современными водными технологиями, создавая чистую, безопасную и устойчивую среду для будущих поколений.",
        // --- ПАРТНЕРЫ ---
        partnersPageTitle: 'Партнеры',
        partnersTitle: 'Международные технологии. Местный опыт. Одна общая цель.',
        partnersDesc: 'National Water Technologies Armenia (NWTA) развивает сеть международного сотрудничества, объединяя ведущих производителей, инженерные компании и технологических партнеров в водном секторе. Наша цель — выбрать и интегрировать для Армении не просто оборудование, а эффективные, надежные и долгосрочные технологические решения.',
        partnersApproachTitle: 'Наш партнерский подход',
        partnersApproachText: 'Мы сотрудничаем со специализированными компаниями из разных стран, подбирая технологию для каждого проекта в зависимости от реальной проблемы, состава воды или сточных вод, требуемой мощности и условий эксплуатации. NWTA является связующим звеном между международными технологиями и их эффективным внедрением в Армении.',
        partnersSubtitle: 'Ведущие международные компании, с которыми мы сотрудничаем',
        partnerType1: 'Партнер по водным технологиям',
        partnerType2: 'Экологические системы',
        partnerType3: 'Решения для промышленных сточных вод',
        partnerType4: 'Очистные сооружения',
        partnerType5: 'Инжиниринг и оборудование',

        // --- НОВОСТИ (БЛОГ) ---
        newsSubtitle: 'Следите за деятельностью NWTA, новыми проектами, международным сотрудничеством и важными разработками в области водных технологий.',
        posts: [
            {
                title: 'Продвинутая автоматизация очистных станций',
                date: 'Март 2026',
                desc: 'Как интеллектуальные датчики повышают эффективность и снижают затраты.',
                image: news1
            },
            {
                title: 'Новые стратегии повторного использования воды',
                date: 'Февраль 2026',
                desc: 'Как организации могут контролировать потребление воды и снижать потери.',
                image: news2
            },
            {
                title: 'Соответствие экологическим требованиям',
                date: 'Январь 2026',
                desc: 'Эффективные решения для соблюдения экологических стандартов.',
                image: news3
            }
        ],
        blogReadMore: 'Читать далее',
        blogViewAll: 'Смотреть все новости',
        backButton: 'Назад',
        allNewsTitle: 'Все новости',
        unitingTitle: 'Мы объединяем',
        unitingItems: [
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>`,
                title: 'Производители',
                desc: 'Специализированное оборудование для очистки воды и сточных вод.'
            },
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="8"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/></svg>`,
                title: 'Технологические компании',
                desc: 'Биологические, мембранные, физико-химические и другие передовые технологии.'
            },
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>`,
                title: 'Инженерные компании',
                desc: 'Совместное проектирование и реализация сложных и крупных проектов.'
            },
            {
                icon: `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
                title: 'Местные специалисты',
                desc: 'Монтаж, пусконаладка, обслуживание и техническая поддержка в Армении.'
            }
        ],

        projectsTitle: 'ПРОЕКТЫ И РЕШЕНИЯ',
        projectsSubtitle: 'Инженерные решения для воды и современной инфраструктуры',
        projectCategories: [
            { label: 'Все', value: 'All' },
            { label: ' Муниципальные', value: 'Municipal' },
            { label: ' Промышленные', value: 'Industrial' },
            { label: ' Отели', value: 'Hotels' },
            { label: ' Жилые', value: 'Residential' },
            { label: ' Санитарные', value: 'Sanitary' },
        ],
        projects: [
            {
                title: 'ОЧИСТКА СТОЧНЫХ ВОД НАСЕЛЁННЫХ ПУНКТОВ',
                category: 'Municipal',
                image: 'img1',
                desc: 'Современные модульные и децентрализованные системы очистки для городов и общин.'
            },
            {
                title: 'ОЧИСТКА ПРОМЫШЛЕННЫХ СТОЧНЫХ ВОД',
                category: 'Industrial',
                image: 'img2',
                desc: 'Комплексные решения по очистке промышленных сточных вод с учётом особенностей каждого производства.'
            },
            {
                title: 'ОЧИСТКА СТОЧНЫХ ВОД ДЛЯ ОТЕЛЕЙ И ТУРИСТИЧЕСКИХ КОМПЛЕКСОВ',
                category: 'Hotels',
                image: 'img3',
                desc: 'Компактное и бесшумное решение для премиальных отелей и зон отдыха.'
            },
            {
                title: 'ЛОКАЛЬНЫЕ СИСТЕМЫ ОЧИСТКИ ДЛЯ ЖИЛЫХ КОМПЛЕКСОВ',
                category: 'Residential',
                image: 'img4',
                desc: 'Компактные и автоматизированные системы очистки сточных вод для жилых комплексов и новых застроек.'
            },
            {
                title: 'ВОДОПОДГОТОВКА И ПОВТОРНОЕ ИСПОЛЬЗОВАНИЕ ВОДЫ',
                category: 'Sanitary',
                image: 'img5',
                desc: 'Современные системы очистки, обработки и повторного использования воды для эффективного управления водными ресурсами.'
            },
            {
                title: 'СОВРЕМЕННАЯ САНИТАРНАЯ ИНФРАСТРУКТУРА',
                category: 'Municipal',
                image: 'img6',
                desc: 'Современные автоматизированные санитарные решения для городов, туристических зон и общественных пространств.'
            }
        ],
        timelineTitle: 'Услуги',
        timelineSubtitle: 'Полный цикл реализации водных и экологических проектов — от обследования объекта до технического обслуживания.',
        servicesSteps: [
            { num: '01', title: 'Обследование и анализ объекта', desc: 'Выезд на объект, сбор исходных данных, анализ воды и сточных вод, определение технических требований.', image: service1 },
            { num: '02', title: 'Инженерное проектирование', desc: 'Разработка технологической схемы, расчёт необходимой мощности и проектных решений.', image: service2 },
            { num: '03', title: 'Выбор технологии и оборудования', desc: 'Подбор оптимальной технологии и соответствующего оборудования для каждого объекта.', image: service3 },
            { num: '04', title: 'Поставка оборудования', desc: 'Комплектация проекта, организация логистики и доставка оборудования на объект.', image: service4 },
            { num: '05', title: 'Монтаж и пусконаладка', desc: 'Установка систем, подключение, настройка автоматики и запуск системы.', image: service5 },
            { num: '06', title: 'Обслуживание и техническая поддержка', desc: 'Проверка, настройка и корректировка параметров.', image: service6 },
            { num: '07', title: 'Сервис', desc: 'Периодическое обслуживание, контроль работы, модернизация и техническая поддержка.', image: service7 }
        ],
        // --- КОНТАКТЫ ---
        contactTitle: 'Контакты',
        contactHeading: 'Давайте обсудим Ваш проект',
        contactIntro: 'У Вас есть проблема с очисткой воды или сточных вод, планируете новый проект или ищете подходящее технологическое решение? Команда NWTA готова изучить Вашу задачу и предложить эффективное инженерное решение.',
        companyName: 'National Water Technologies Armenia LLC',
        contactAddressLabel: 'Адрес',
        contactPhoneLabel: 'Телефон',
        contactEmailLabel: 'Email',
        contactFormTitle: 'Отправьте нам Ваш запрос',
        contactFormSubtitle: 'Свяжитесь с нами, предоставив основную информацию о проекте.',
        contactLabelName: 'Имя / Фамилия',
        contactLabelCompany: 'Компания / Организация',
        contactLabelPhone: 'Телефон',
        contactLabelEmail: 'Эл. почта',
        contactLabelProjectType: 'Тип проекта',
        contactSelectProject: 'Выберите тип проекта',
        contactOptMunicipal: 'Муниципальная очистка сточных вод',
        contactOptIndustrial: 'Промышленная очистка сточных вод',
        contactOptDrinking: 'Очистка питьевой воды',
        contactOptLocal: 'Локальная очистная станция',
        contactOptOther: 'Другое',
        contactLabelMessage: 'Сообщение',
        contactPlaceholderName: 'Ваше имя',
        contactPlaceholderEmail: 'example@mail.com',
        contactPlaceholderPhone: '+374 XX XXXXXX',
        contactPlaceholderMessage: 'Напишите ваше сообщение...',
        contactButtonSend: 'Отправить запрос',
        contactSentSuccess: 'Ваше сообщение успешно отправлено.',
        contactCooperationTitle: 'Для сотрудничества',
        contactCooperationText: 'Мы открыты для сотрудничества с государственными и муниципальными структурами, частными компаниями, застройщиками, промышленными предприятиями, инженерными организациями и международными технологическими партнерами.',
        contactCooperationTagline: 'Начнем с проблемы. Найдем правильное решение. Реализуем вместе.',

        waterclean: {
            badge: "WaterClean",
            title: "ОЧИСТКА ПИТЬЕВОЙ ВОДЫ И ВОДОПОДГОТОВКА",
            description: "NWTA предлагает современные решения по очистке питьевой воды...",
            quote: "Чистая вода начинается с правильного решения",
            quoteSub: "NWTA помогает выбрать систему очистки воды...",


            services: [
                {
                    title: "Фильтрация питьевой воды",
                    description: "Чистая и безопасная вода для ежедневного использования.",
                },
                {
                    title: "Обратный осмос",
                    description: "Глубокая очистка воды и удаление нежелательных примесей.",
                },
                {
                    title: "Умягчение воды",
                    description: "Снижение жёсткости и защита оборудования от накипи.",
                },
                {
                    title: "Комплексная водоподготовка",
                    description: "Удаление железа, механических примесей, запаха и других загрязнителей.",
                },
                {
                    title: "Пурифайеры и диспенсеры",
                    description: "Современные решения питьевой воды для офисов, школ, гостиниц и общественных пространств.",
                },
            ],
        },
    }
};

export const defaultLanguage = 'ARM';
export const supportedLanguages = ['ARM', 'ENG', 'RU'];